import { render, staticRenderFns } from "./DetectionWriteComponent.vue?vue&type=template&id=6064ec16&scoped=true&"
import script from "./DetectionWriteComponent.vue?vue&type=script&lang=js&"
export * from "./DetectionWriteComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6064ec16",
  null
  
)

export default component.exports